<div class="ui-search">
  <span class="ui-search__icon" aria-hidden="true">
    <ui-icon name="search" size="sm" />
  </span>
  <input
    class="ui-search__input"
    type="search"
    [placeholder]="placeholder"
    [value]="value"
    [attr.aria-label]="ariaLabel"
    (input)="onInput($event)"
    (blur)="onTouched()"
  />
  @if (value) {
    <button
      type="button"
      class="ui-search__clear"
      aria-label="Effacer la recherche"
      (click)="clear()"
    >
      <ui-icon name="close" size="sm" />
    </button>
  }
</div>
